var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFE3AC",
    cx: 8.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#BFC9EE",
    y: 16,
    width: 17,
    height: 28,
    rx: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.5 18)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#93DFDC",
    cx: 8.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#7F93E0",
    y: 16,
    width: 17,
    height: 35,
    rx: 3.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.5 11)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BCADF9",
    cx: 8.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#3454D1",
    y: 16,
    width: 17,
    height: 42,
    rx: 3.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphStatistics);
export default __webpack_public_path__ + "static/media/icons_graph_statistics.5abfc4082d90e6db9f8730e3c4f51661.svg";
export { ForwardRef as ReactComponent };